// M8.1 Catalog V2 — mount the shipped CatalogBrowser at /v2/catalog so
// M7.3 attention marks + inline nudges activate (gated inside the shipped
// `CatalogBrowser/Sidebar.tsx` by `isAgentV2Route(pathname)`). This flag
// does NOT paint marks itself — M7.3 did that already. This flag's only
// job is to register the /v2/catalog route so that path becomes reachable
// and `isAgentV2Route` returns true for it.
//
// Strict `=== 'true'` per D-S10 in #131. Unset / 'false' / '1' / 'yes' /
// 'TRUE' all stay off, matching PerformanceV2 / SettingsV2 / ConnectionsV2.
export function isCatalogV2Enabled(): boolean {
  return import.meta.env.VITE_CATALOG_V2_ENABLED === 'true';
}
